import React from "react";
import { useCallback, useEffect, useRef } from 'react';

const GOOGLE_INIT_DELAY = 500;
const GOOGLE_INIT_TRIES = 10

const GoogleAuth = ({ 
    authSuccessful,
    setSuccess
} : { 
    authSuccessful: Function,
    setSuccess: React.Dispatch<React.SetStateAction<boolean | undefined>>
}) => {
    const googleButton = useRef(null);
    const tries = useRef(0);

    const initializeGoogleButton = useCallback(() => {
        if (tries.current < GOOGLE_INIT_TRIES) {
            try {
                google.accounts.id.initialize({
                    client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
                    callback: (response: any) => authSuccessful(response.credential),
                })
                google.accounts.id.renderButton(
                    googleButton.current,
                    { theme: 'outline', size: 'large', width: '240px' }
                )
                setSuccess(true);
            } catch (e) {
                console.log("Unable to initiate google auth, retrying...");
                tries.current++;
                setTimeout(() => { initializeGoogleButton() }, GOOGLE_INIT_DELAY);
            }
        } else {
            console.log("Unable to initiate google auth");
            setSuccess(false);
        }
    }, [authSuccessful, setSuccess]);

    useEffect(() => {
        setTimeout(() => { initializeGoogleButton() }, GOOGLE_INIT_DELAY);
    }, [initializeGoogleButton])

    return (
        <div ref={googleButton} />
    )
}

export default GoogleAuth